import { createNamespacedHelpers } from 'vuex'
import Theme from '~/constants/theme'

const { mapActions: mapEnvActions, mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export const LIGHT_ONLY_ROUTES = ['^/bedrooms']

const UIMixin = {
  computed: {
    ...mapEnvGetters([
      'isWebview',
      'isDarkTheme'
    ])
  },

  created () {
    if (this.isWebview) {
      if (LIGHT_ONLY_ROUTES.some(r => new RegExp(r, 'g').test(this.$route.path))) {
        return
      }

      this.setThemeColor(Theme.Dark)
    } else if (!this.$route.meta.hasOwnTheme) {
      this.setThemeColor(this.$route.meta.theme)
    }
  },

  methods: {
    ...mapEnvActions(['setThemeColor'])
  }
}

export default UIMixin
